<template>
    <span class="sms">
        <span @click="toggleMessage" class="material-icons txt green-secondary" style="margin:0px 10px; font-weight: 100;">sms</span>
        <div v-if="showMessage" class="sms-message">
            <forms action="/messages" method="POST">
                <textarea rows="7" name="message">{{ message }}</textarea>
                <input type="hidden" name="user" :value="userId" />
                <confirm-button classes="button block small" value="Send SMS" message="Sending"></confirm-button>
            </forms>
        </div>
    </span>
</template>

<script>
module.exports = {
    created: function () {

    },
    data:function() {
        return {
            showMessage: false
        }
    },
    props:{
        userId:{type:Number},
        message:{type:String}
    },
    methods: {
        toggleMessage:function() {
            this.showMessage = !this.showMessage
        }
    },
    mounted:function() {

    }
}
</script>
